import { render, staticRenderFns } from "./category-filed.vue?vue&type=template&id=1d20f1ba&"
import script from "./category-filed.vue?vue&type=script&lang=js&"
export * from "./category-filed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports